export const SCHEDULING_INFO_COL = [

  {
    // title: '计划单号',
    dataIndex: 'orderNo',
    align: 'left',
    width: 200,
    scopedSlots: { customRender: 'orderNo', title: 'orderNoTitle' }
  },
  { title: '工单号', dataIndex: 'wipEntityName', width: 130 },
  { title: '物料编码', dataIndex: 'itemCode', width: 140 },
  { title: '物料名称', dataIndex: 'itemName', width: 140, scopedSlots: { customRender: 'textEllipsis' } },
  { title: '规格描述', dataIndex: 'specificationDesc', width: 160, scopedSlots: { customRender: 'textEllipsis' } },
  { title: '大工序', dataIndex: 'mainProcessCodeName', width: 60 },
  { title: '计划数量', dataIndex: 'planQuantity', width: 90, align: 'center' },
  { title: '排单状态', dataIndex: 'statusName', width: 90 },
  { title: '一次考核交期', dataIndex: 'initialAssessmentDeliveryDate', width: 145, scopedSlots: { customRender: 'formatDate' } },
  { title: '变更后考核交期', dataIndex: 'changedAssessmentDeliveryDate', width: 145, scopedSlots: { customRender: 'formatDate' } },
  { title: '工单状态', dataIndex: 'workOrderStatusName', width: 90 },
  { title: '创建人', dataIndex: 'createName', width: 90 },
  { title: '创建时间', dataIndex: 'createTime', width: 145, scopedSlots: { customRender: 'formatDate' } },
  { title: '更新人', dataIndex: 'updateName', width: 90 },
  { title: '更新时间', dataIndex: 'updateTime', width: 145, scopedSlots: { customRender: 'formatDate' } }
]
